<div class="row">
  <div class="col-md-12">
    <div class="title-type">
      <div class="label form-label title-attribute">{{attribute.name}} {{ attribute.required ? '*' : ''}}</div>
    </div>
  </div>
</div>
